import { useEffect, useState, useMemo } from "react";
import { useSignal } from "@preact/signals-react";

import TableCustomFilter from "componentsv2/experimental/TableCustomFIlter";
import BasicTable from "componentsv2/table/BasicTable";
import TableHeader from "./TableHeader";
import { genStoreId } from "componentsv2/tools/functions";
import { insertRecord, useStore } from "storev2/formStore";
import { useTable } from "storev2/tableStore";
import { cn } from "tools/ui";

// import { useStoreRecords } from "storev2/store-hooks";

/**
 * @param {Array } layout
 * @param {Function} handleView
 * @return
 */
function BoardTable({
  name,
  layout,
  parentRec,
  height,
  style,
  reloadId,
  handleView,
  onChange,
  showBackButton,
  returnFilter,
  setView,
  reload,
  recordStoreId: externalRecordStoreId,
  openModal: externalOpenModal,
  records: externalRecords,
}) {
  const [offset, setOffset] = useState(0);
  const internalRecordStoreId = useSignal(null);
  const internalOpenModal = useSignal(false);
  const recordStoreId = externalRecordStoreId || internalRecordStoreId;
  const openModal = externalOpenModal || internalOpenModal;
  // const { reload: reloadForm } = useStore();

  const storeId = genStoreId(layout.model, null, parentRec?.storeId);
  const { presetTable, reload: reloadTable } = useTable();
  const table = useTable((state) => state[storeId]);

  const records = externalRecords || table?.records || [];

  const limit = layout?.limit ?? 100;

  const hasFilterFields = useMemo(() => {
    if (!layout?.fields) return false;
    return Object.values(layout.fields).some((field) => field.filter);
  }, [layout?.fields]);

  const actionButtons = [];

  if (layout.table_action?.includes("remove")) {
    const action = "remove";
    if (
      (Array.isArray(action) && action.includes(parent?.state)) ||
      action === true
    ) {
      // if (!props.readOnly) {
      //   actionButtons.push("button_remove");
      // }
    }
  }
  if (layout.table_action?.includes("update")) {
    actionButtons.push("button_edit");
  }

  function onClickRow(value) {
    const { [storeId]: currentTable } = useTable.getState();
    const selectedValues = currentTable?.selected
      ? Array.from(currentTable.selected.values()).map((val) => val.id)
      : [];
    if (onChange) {
      onChange(name, selectedValues);
    }
  }

  function handleSelectAll(selectAll) {
    const { [storeId]: currentTable } = useTable.getState();
    const selectedValues = currentTable?.selected
      ? Array.from(currentTable.selected.values()).map((val) => val.id)
      : [];
    if (onChange) {
      onChange(name, selectedValues);
    }
  }

  function onChangePage(_activePage) {
    const newOffset = (_activePage - 1) * limit;
    setOffset(newOffset);
    reloadTable(storeId, { offset: newOffset });
  }

  useEffect(() => {
    if (externalRecords) return;
    presetTable(storeId, layout, parentRec);
  }, [parentRec?.record?.id, reloadId]);

  async function handleTableView(action, recId) {
    let recStoreId = null;
    if (["open", "edit"].includes(action)) {
      recStoreId = await insertRecord(recId, layout.model, layout);
      // recordStoreId.value = recStoreId;
    } else {
      // This is action === "add"
      const { newRecord } = useStore.getState();
      recStoreId = await newRecord(layout, parentRec);
      recordStoreId.value = recStoreId;
    }
    if (layout.display === "board") {
      // console.log(
      //   "handleView... ahora no abre modal",
      //   action,
      //   recId,
      //   recStoreId,
      // );
      // console.log("Display_form? ", layout.display_form, recStoreId);
      handleView(action, recStoreId);
      // recordId.value = recordStoreId.value;
      // currentView.value = "form";
    } else {
      openModal.value = true;
    }
  }

  async function closeModal(mustReload) {
    if (mustReload?.value) {
      if (parentRec?.record.id > 0) {
        console.log("paso para hacer reload en board table");
        await reload();
      }
    }
  }

  const count = records.length || 0;
  // console.log("table....", table);
  return (
    <div id="board-table" className={cn("w-full mt-3 ", height, style)}>
      <TableHeader
        layout={layout}
        handleView={handleTableView}
        handleReturn={returnFilter || handleView}
        storeId={storeId}
        count={count}
        kind={parentRec ? "small" : "big"}
        showBackButton={showBackButton}
        returnFilter={returnFilter}
        setView={setView}
      />
      {hasFilterFields && (
        <TableCustomFilter
          layout={layout}
          storeId={storeId}
          handleView={handleTableView}
        />
      )}
      <BasicTable
        storeId={storeId}
        layout={layout}
        model={layout.model}
        records={records}
        limit={limit}
        offset={offset}
        countRecords={count}
        actionButtons={actionButtons}
        onChangePage={onChangePage}
        closeModal={closeModal}
        recordStoreId={recordStoreId}
        parentRec={parentRec}
        openModal={openModal}
        handleView={handleTableView}
        reloadId={reloadId}
        reload={reload}
        // refetch={refetch} No debe ser necesario
        onClickRow={onClickRow}
        onSelectAll={handleSelectAll}
        // triggerUpdate={onChange}
      />
    </div>
  );
}

export default BoardTable;
